<template>
  <div class="GlobalInfoBar">
    <div v-if="type === 'common'" class="info-bar-container">
      <div class="info-bar" :class="{ 'info-bar_inline': inline }">
        <!--商店image-->
        <img v-if="icon==='shop'" class="info-bar_icon" src="@/assets/images/icon_sjlb_@2x.png" alt />
        <!--回收image-->
        <img v-if="icon==='recycle'" class="info-bar_icon" src="@/assets/images/icon_hs__@2x.png" alt />
        <div class="info-bar_content">
          <h5>
            <span>{{title}}</span>
            <slot name="titleRight"></slot>
          </h5>
          <p>
            {{content}}<span v-if="contentOn" class="text-on">{{contentOn}}</span><span @click="jumAny(pathName)" v-if="consent" class="textJum">{{consent}}</span>{{ confeiger?confeiger:'' }}
            <slot name="contentRight"></slot>
          </p>
        </div>
        <slot name="rightSlot"></slot>
      </div>
    </div>
    <div v-if="type === 'hint'" class="info-bar-container hint-container">
      <div class="info-bar">
        <img class="info-bar_icon" src="@/assets/images/icon_th@2x.png" alt />
        <div class="info-bar_content">
          <h5>{{title}}</h5>
          <p>{{content}}</p>
        </div>
        <div class="iphone-info">
          <!--<img class="iphone-info_icon" src="@/assets/images/icon_th@2x.png" alt />-->
          <img class="iphone-info_icon" src="@/assets/images/icon_lxgl@2x.png" alt />
          <span>联系管理员</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalInfoBar',
  props: {
    title: String,
    content: String,
    contentOn: String,
    consent: String,
    confeiger: String,
    pathName:String,
    // type: common/hint
    type: {
      type: String,
      default: 'common'
    },
    // icon: shop/recycle
    icon: {
      type: String,
      default: 'shop'
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    jumAny(path){
       this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.info-bar-container {
  margin-bottom: 20px;
  .info-bar {
    padding: 10px 20px 10px 20px;
    background: #E4ECFD;
    border-radius: 33px;
    display: flex;
    align-items: center;
    &_icon {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    &_content {
      > h5{
        font-size: 18px;
        font-weight: 700;
        color: #242D3E;
        line-height: 20px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;

        /deep/ .el-tag {
          margin-left: 14px;
          font-weight: 400;
        }
      }
      > p {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        display: flex;
        align-items: center;

        img {
          width: 36px;
          height: 36px;
          margin-left: 8px;
          cursor: pointer;
        }
      }
    }

    &_inline {
      .info-bar_content {
        display: flex;
        align-items: center;

        > h5 {
          margin-bottom: 0;
          margin-right: 10px;
        }

        > p {
          margin-bottom: 0;
        }
      }

      /deep/ .el-button--text {
        margin-left: 48px;
        color: #FF687B;
        text-decoration: underline;
      }
    }
  }
  .text-on{
    color: #FF687B;
  }
  .textJum{
    color: #0981FF;
  }
}

.hint-container{
  .info-bar {
    padding: 4px 10px 4px 10px;
    background: #FFEBEB;
    border-radius: 25px;
    position: relative;
    &_icon {
      width: 22px;
      height: 22px;
      margin-right: 11px;
    }

    &_content {
      > h5{
        font-size: 14px;
        font-weight: 400;
        color: #FF8080;
        margin-bottom: 0;
      }
      > p {
        font-size: 14px;
        font-weight: 400;
        color: #242D3E;
      }
    }

    .iphone-info{
      position: absolute; right: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #242D3E;
      display: flex; align-items: center;
      &_icon{
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
  }
}
</style>
